































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { LearningPathCourse } from 'frontend/store/modules/next-learning-path-course';
import ProgressBar from './ProgressBar.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import LearningPathPill from 'frontend/views/learningPathV2/LearningPathPill.vue';
import CircleCheckMarkIcon from 'frontend/components/icons/CircleCheckMarkIcon.vue';
import { ExperimentGetter } from 'frontend/types';
import CardBackground from 'frontend/views/courses/CoursePage/components/CardBackground.vue';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';

@Component({
  components: {
    BriocheBackgroundImage,
    CardBackground,
    CircleCheckMarkIcon,
    LearningPathPill,
    ProgressBar,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
    ...mapGetters('globals', ['inExperiment']),
  },
})
export default class LLPDaisyChain extends Vue {
  @Prop({ type: Object, required: true })
  private nextLearningPathCourse!: LearningPathCourse;

  private readonly learningPath!: RelatedLearningPathInfo;
  private readonly inExperiment!: ExperimentGetter;

  private get isInLLPNuxRecsExperiment(): boolean {
    return !!this.learningPath && this.inExperiment('um_llp_nux_recs_05_2023', 'experiment');
  }

  private get courseHref(): string {
    return `/courses/${this.nextLearningPathCourse.course.slug}/?from_llp=${this.learningPath.slug}`;
  }

  private get hasProgress(): boolean {
    return this.nextLearningPathCourse.course.percent_complete > 0;
  }

  private get percentComplete(): number {
    return this.nextLearningPathCourse.course.percent_complete / 100;
  }

  private get isCourseComplete(): boolean {
    return this.nextLearningPathCourse.course.percent_complete === 100;
  }

  private get learningPathForPill(): RelatedLearningPathInfo {
    return {
      ...this.learningPath,
      level_number: this.nextLearningPathCourse.level_number,
      level_highlighted_image_url: this.nextLearningPathCourse.level_highlighted_image_url,
    };
  }

  private get nextCoursePosition(): number {
    if (this.learningPath.level_number === this.nextLearningPathCourse.level_number) {
      return this.learningPath.course_position + 1;
    }
    return 1;
  }
}
